import {
    useLocation,
    useNavigate } from "react-router-dom";
import useUiController from "../../global/hooks/useUiController";
import { useSelector } from "react-redux";
import SnpBaseLayout from "../../global/SnpBaseLayout";
import { useEffect,
    useState } from "react";
import { INITIAL_COLOR_MODEL,
    INITIAL_GOLD_INVENTORY_FORM,
    INITIAL_GOLD_RECORD_FORM,
    INITIAL_SUPPLIER } from "../productConstant";
import {
  getAuthSession,
  getPreUrlAccordingToCart,
  isEmpty,
  isNumberEmpty,
  ItemStatus,
  local_test_url,
  printDebugLog,
  SUCCESS
} from "../../../constants/constant";
import { Autocomplete, Box, Button, Card, FormControl, FormControlLabel, FormLabel, Grid, Paper, Radio, RadioGroup, Stack, Switch, TextField, Typography } from "../../ui";
import ThreeDText from "../../global/ThreeDText";
import SnpButton from "../../global/SnpButton";
import axios from "axios";
import { snpAxios } from "../../global/api";
import uiUtilInstance from "../../../utilities/uiUtil";
import DismissButton from "../../global/DismissButton";
import utilities from "../../../utilities/utilities";
import { EncodeBase64UrlSafe } from "../../../utilities/base64Utilities";

import imageUploadService from "../../../service/imageUploadService";
import FileUploadIcon from '../../ui/icons/FileUpload';

const GoldSupplierRecord = () => {


    const {
        loader,
        setLoader,
        snackbarConfig,
        showSnackbar,
        closeSnackbar,
        dialogConfig,
        showDialog,
        closeDialog,
    } = useUiController();

    const location = useLocation();
    const navigate = useNavigate();
    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);

    const [listConversion, setListConversion] = useState([]);
    const [listProduct, setListProduct] = useState([]);
    const [supplierData, setSupplierData] = useState([]);

    const [goldRecords, setGoldRecords] = useState(INITIAL_GOLD_INVENTORY_FORM);
    const [goldSupplierRecords, setGoldSupplierRecords] = useState(INITIAL_GOLD_RECORD_FORM);
    const [supplierSingleData, setSupplierSingleData] = useState(INITIAL_SUPPLIER);

    const [listColor, setListColor] = useState([]);
    const [frontColorModel, setFrontColorModel] = useState(INITIAL_COLOR_MODEL);

    const [listBackColor, setListBackColor] = useState([]);
    const [backColor, setBackColor] = useState(INITIAL_COLOR_MODEL);

    const [imageSelectedError, setImageSelectedError] = useState(false);
    const [uploadedDocument, setUploadedDocument] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);


    const handleImaeUpload = (event) => {
        const { name, value } = event.target;
        printDebugLog("AddProduct:handleProductChange", name, value);
        if (name === "imgPath") {
            const imageList = event.target.files;
            printDebugLog("imgPath=>", imageList);

            if (imageList && imageList.length > 0) {
                setImageSelectedError(false);

                const reader = new FileReader();
                const file = imageList[0];

                reader.onloadend = function () {
                    setSelectedImage(reader.result);
                    setUploadedDocument(file);
                };

                reader.readAsDataURL(file);
            } else {
                setImageSelectedError(true);
            }
        }
    }

    const fetchAutoCompleteDetails = async (id, regextStr) => {
        const cartTypeStr = getPreUrlAccordingToCart(storeActiveShopHash.cartType);
        let urlType = "";
        if (id === 'search-front-color') {
            urlType = `fetch-color?color=${regextStr}`;
        } else if (id === 'search-back-color') {
            urlType = `fetch-color?color=${regextStr}`;
        }
        try {
            const fetchBillUrl = `${storeApiUrl.BACKEND_BASE_URL}${cartTypeStr}${urlType}`;
            const response = await axios.get(fetchBillUrl);
            printDebugLog("fetchAutoCompleteDetails   => ", regextStr, response.data);
            if (!isEmpty(response.data)) {
                if (id === 'search-front-color') {
                    if (response.data.status === SUCCESS) {
                        setListColor(response.data.jcJson.snpColorModelList);
                    } else {
                        setListColor([]);
                    }
                } else if (id === 'search-back-color') {
                    if (response.data.status === SUCCESS) {
                        setListBackColor(response.data.jcJson.snpColorModelList);
                    } else {
                        setListBackColor([]);
                    }
                }

            } else {
                if (id === 'search-front-color') {
                    setListColor([]);
                } else if (id === 'search-back-color') {
                    setListBackColor([]);
                }

            }

        } catch (error) {
            console.error("fetchAutoCompleteDetails errr ", error);
            if (id === 'search-front-color') {
                setListColor([]);
            } else if (id === 'search-back-color') {
                setListBackColor([]);
            }
        }
    };


    const getSupplierDetails = async () => {
        try {
            const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}fetch-supplier-few-details?token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}`;
            const response = await snpAxios.get(cartUrl);
            if (response.data.status === SUCCESS) {
                setSupplierData(response.data.jcJson.value_2);
            }
        } catch (e) {
            console.log("getSupplierDetails errr ", e);
        }
    };

    const getProductDetails = async (e, optPage = 0, optTotal = 0) => {
        const { name, value } = e.target;
        setGoldRecords(prev => ({
            ...prev,
            [name]: value,
        }))
        try {
            if (value && value.length > 2) {
                const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-gold-inventory?token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}&stock=${value}&page=${optPage}&total=${optTotal}`;
                const response = await axios.get(cartUrl);
                if (response.data.status === SUCCESS) {
                    const payLoad = response.data.jcJson;
                    setListProduct(payLoad.fullData);
                } else {
                    setListProduct([]);
                }
            }
        } catch (error) {
            console.error("getProductDetails", value, optPage, optTotal, error);
            setListProduct([]);
        }
    };

    const getProductId = async (id) => {
        try {
            const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-gold-inventory-by-id?id=${id}&shopHash=${storeActiveShopHash.id}`;
            const response = await snpAxios.get(cartUrl);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setGoldRecords(payLoad);
                getConversion(payLoad.cnvId);
                setGoldSupplierRecords(prev => ({
                    ...prev, imagePath: payLoad.image,
                }))
            } else {
                setGoldRecords(INITIAL_GOLD_INVENTORY_FORM);
                setGoldSupplierRecords(prev => ({
                    ...prev, imagePath: "",
                }))
            }
        } catch (error) {
            console.error("getProductId", id, error);
            setGoldRecords(INITIAL_GOLD_INVENTORY_FORM);
        }
    };

    const getSupplerRecordById = async (id) => {
        try {
            const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-gold-record-by-id?id=${id}&shopHash=${storeActiveShopHash.id}`;
            const response = await snpAxios.get(cartUrl);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setGoldRecords(payLoad.inventory);
                if (!isEmpty(payLoad.records.frontColorModelId)) {
                    setFrontColorModel(prev => ({
                        ...prev,
                        colorId: payLoad.records.frontColorModelId,
                        colorCode: payLoad.records.frontColorModelCode,
                        colorDetails: payLoad.records.frontColorModelDetails,
                    }))
                }
                if (!isEmpty(payLoad.records.backColorModelId)) {
                    setBackColor(prev => ({
                        ...prev,
                        colorId: payLoad.records.backColorModelId,
                        colorCode: payLoad.records.backColorModelCode,
                        colorDetails: payLoad.records.backColorModelDetails,
                    }))
                }
                getConversion(payLoad.inventory.cnvId);
                setGoldSupplierRecords(payLoad.records);
                setSupplierSingleData(payLoad.supplierSingleData);
            } else {
                setGoldRecords(INITIAL_GOLD_INVENTORY_FORM);
                setGoldSupplierRecords(INITIAL_GOLD_RECORD_FORM);
            }
        } catch (error) {
            console.error("getProductId", id, error);
            setGoldRecords(INITIAL_GOLD_INVENTORY_FORM);
            setGoldSupplierRecords(INITIAL_GOLD_RECORD_FORM);
        }
    };

    const getConversion = async (id) => {
        try {
            setLoader(true);
            const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-single-conversion?cnv=${id}`;
            const response = await axios.get(cartUrl);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setListConversion(payLoad.conversionList);
            } else {
                setListConversion([]);
            }
            setLoader(false);
        } catch (error) {
            console.error("getConversion", id, error);
            setListConversion([]);
            setLoader(false);
        }
    };


    const handleImageUpload = async () => {
        if (!isValid()) {
            return;
        }
        printDebugLog("handleImageUpload", goldSupplierRecords);

        if (uploadedDocument) {
            setLoader(true);
            let formData = new FormData();
            formData.append('fnm', getAuthSession().apiToken);
            formData.append("file", uploadedDocument);
            await imageUploadService.upload(storeApiUrl.BACKEND_BASE_URL, getPreUrlAccordingToCart(storeActiveShopHash.cartType), formData).then(response => {
                if (response.data.folderName) {
                    printDebugLog("folderName", response.data.folderName);
                    goldSupplierRecords.gifPath = response.data.folderName;
                    handleSubmitData();
                }
            }
            ).catch(error => {
                handleSubmitData();
                console.error("handleImageUpload = > ", error);
                // window.location.href = "#/error";
            });
        } else {
            handleSubmitData();
        }
    };


    const handleSubmitData = async () => {
        if (!isValid()) {
            return;
        }
        setLoader(true);
        const catgUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}persist-gold-supplier-inventory-record`;
        const filledData = {
            jcJson: {
                apiToken: getAuthSession().apiToken,
                shopHash: storeActiveShopHash.id,
                inventoryId: goldRecords.id,
                supplierId: supplierSingleData.supplierId,
                ...goldSupplierRecords,
                frontColorModelId: frontColorModel?.colorId ?? "",
                backColorModelId: backColor?.colorId ?? "",
            }
        };
        //console.log("handleProductEntry => ", filledData);
        snpAxios.post(
            catgUrl,
            filledData
        ).then(response => {
            printDebugLog("handleSubmitData:responses => ", response.data);
            setLoader(false);
            if (response.data.status === SUCCESS) {
                setUploadedDocument(null);
                setSelectedImage(null);
                setImageSelectedError(false);
                showDialog({
                    ...dialogConfig,
                    negativeReq: true,
                    positiveReq: true,
                    positiveAction: "Ok!",
                    handleSubmit: () => {
                        setGoldSupplierRecords(prev => ({
                            ...prev, id: response.data.jcJson.id,
                        }))
                        closeDialog();
                    },
                    negativeAction: "Go back!", subTitle: "Records updated Successfully",
                    handleClose: () => {
                        closeDialog();
                        navigate("/dashboard/showproduct");
                    },
                });
            }
        }).catch(error => {
            console.error("handleSubmitData : ", error);
            // window.location.href = "#/error";
            setLoader(false);
        });
    };

    const deleteProduct = async () => {
        try {
            setLoader(true);
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}gold-record-delete?deleteId=${goldSupplierRecords.id}&token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}`;
            const response = await snpAxios.get(cUrl);
            if (response.data.status === SUCCESS) {
                showDialog({
                    ...dialogConfig,
                    negativeReq: true,
                    positiveAction: "Create new!",
                    handleSubmit: () => {
                        setGoldSupplierRecords(INITIAL_GOLD_RECORD_FORM)
                    },
                    negativeAction: "Go back!", subTitle: "Product deleted successfully",
                    handleClose: () => {
                        closeDialog();
                        navigate("/dashboard/showproduct");
                    },
                });

            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.error("deleteProduct", goldRecords.id, error);
        }
    };


    useEffect(() => {
        printDebugLog("GoldSupplierRecord", location.state);
        getSupplierDetails();
        if (!isEmpty(location.state?.inventoryId)) {
            getProductId(location.state?.inventoryId);
        }
        if (!isEmpty(location.state?.recordId)) {
            getSupplerRecordById(location.state?.recordId);
        }
    }, [location.state, storeApiUrl, storeActiveShopHash]);

    const handleSearchColor = (event) => {
        const { name, value } = event.target;
        printDebugLog("handleSearchColor", name);
        if (value.length >= 3) {
            fetchAutoCompleteDetails(name, value);
        }
    };

    const handleSelectColorChange = (event, colorModel) => {
        //console.log("handleSelectColorChange", colorModel);
        if (colorModel !== null) {
            setFrontColorModel(colorModel);
        } else {
            setFrontColorModel(INITIAL_COLOR_MODEL)
        }
    };

    const handleBackColor = (event, colorModel) => {
        console.log("handleDialColor", colorModel);
        if (colorModel !== null) {
            setBackColor(colorModel);
        } else {
            setBackColor(INITIAL_COLOR_MODEL)
        }
    };

    const isValid = () => {
        if (isEmpty(supplierSingleData.supplierId)) {
            fireSnackBarMsg({ msg: "Select Supplier Information", mColor: "#ff0000" });
            return false;
        }
        if (isNumberEmpty(goldSupplierRecords.conversionId)) {
            fireSnackBarMsg({ msg: "Select Unit", mColor: "#ff0000" });
            return false;
        }
        if (isNumberEmpty(goldSupplierRecords.weight) && goldSupplierRecords.weight <= 0) {
            fireSnackBarMsg({ msg: "Please enter weight", mColor: "#ff0000" });
            return false;
        }
        return true;
    }

    const handleSelectProduct = (event, row) => {
        if (row !== null) {
            if (isEmpty(row.id)) {
                printDebugLog("handleSelectProduct ", event.target.name, row);
                setGoldRecords(prev => ({
                    ...prev,
                    [event.target.name]: row,
                }));
                setGoldSupplierRecords(prev => ({
                    ...prev, image: row.image,
                }))
                getConversion(row.cnvId);
            } else {
                setGoldRecords({
                    ...row,
                });
                setListConversion([]);
            }
        } else {
            setGoldRecords(INITIAL_GOLD_INVENTORY_FORM);
            setListConversion([]);
        }
    }

    const handleSupplierChange = (event, option) => {
        if (option != null) {
            setSupplierSingleData(option);
        } else {
            setSupplierSingleData(INITIAL_SUPPLIER);
        }
    };

    const fireSnackBarMsg = ({ msg, mHorizontal = "right", mVertical = "top", mColor = "#008b8b" }) => {
        showSnackbar(msg, mColor, mVertical, mHorizontal);
    };

    const old_handlePreviewEcart = () => {
        const queryData = `id=${utilities.encodeString(goldSupplierRecords.id)}&shopHash=${utilities.encodeString(storeActiveShopHash.id)}`;
        let encodedString = utilities.encodeString(queryData);
        encodedString = EncodeBase64UrlSafe(encodedString);
        printDebugLog("handlePreviewEcart", queryData, encodedString);
        window.open(`${window.location.origin}/#/gold-stock?query-data=${encodedString}`, "_blank", "noreferrer");
    };


    const handlePreviewEcart = () => {
        const queryData = `id=${utilities.encodeString(goldSupplierRecords.id)}&shopHash=${utilities.encodeString(storeActiveShopHash.id)}`;
        let encodedString = utilities.encodeString(queryData);
        encodedString = EncodeBase64UrlSafe(encodedString);
        printDebugLog("handlePreviewEcart", queryData, encodedString);
        window.open(`${window.location.origin}/#/gold-stock?id=${goldSupplierRecords.id}&shopHash=${storeActiveShopHash.id}`, "_blank", "noreferrer");
    };


    const printProduct = async () => {
        try {
            setLoader(true);
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}print-gold-catalogue?apiToken=${getAuthSession().apiToken}&id=${goldSupplierRecords.id}&token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}`;
            const response = await snpAxios.get(cUrl);
            if (response.data.status === SUCCESS) {
                const printData = response.data.jcJson.path;
                window.open(`${storeApiUrl.BACKEND_BASE_URL}files/${printData}`, '_blank');
            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.error("deleteProduct", goldRecords.id, error);
        }
    }

    return (
        <SnpBaseLayout
            loader={loader}
            snackbarConfig={{ ...snackbarConfig, onClose: closeSnackbar }}
            dialogConfig={dialogConfig}
        >
            <Grid container spacing={1}>
                <Grid item xs={10}>
                    <ThreeDText
                        text="Supplier Record Information"
                        display=""
                        className="three-d-text-container"
                        justifyContent="left"
                        alignItems="left" />
                </Grid>
                <Grid item xs={12}>
                    <Paper elevation={10}
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            backgroundColor: "#FEF7DA",
                            boxShadow: 1,
                            borderRadius: 4,
                            padding: 1,
                        }} >
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={6} sm={6} lg={6}>
                                <Autocomplete
                                    id="name"
                                    freeSolo
                                    options={listProduct}
                                    autoHighlight
                                    size="small"
                                    variant="filled"
                                    value={goldRecords}
                                    onChange={handleSelectProduct}
                                    onBlur={() => setListProduct([])}
                                    getOptionLabel={(option) => (option ? option?.name : "")}
                                    renderOption={(props, option) => (
                                        <Box component="li" {...props} key={option.id}>
                                            {uiUtilInstance.getGoldLabel(option)}
                                        </Box>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            name="name"
                                            label="Search / Enter Item"
                                            onChange={(e) => getProductDetails(e)}
                                            sx={{
                                                minWidth: 250,
                                                mx: "auto",
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            {
                                !isEmpty(goldRecords.id) &&
                                <Grid item xs={12} md={6} sm={6} lg={6}>
                                    <Paper
                                        elevation={10}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column", // stack vertically
                                            justifyContent: "center",
                                            alignItems: "flex-start", // left align text inside
                                            backgroundColor: "#fffefcff",
                                            boxShadow: 1,
                                            borderRadius: 2,
                                            padding: "8px 12px", // nice padding

                                            mx: "auto", // center horizontally
                                        }}
                                    >
                                        <p
                                            style={{
                                                margin: 0,
                                                whiteSpace: "pre-wrap",
                                                overflowWrap: "break-word",
                                                color: "blueviolet",
                                                fontFamily: "sans-serif",
                                                fontSize: "15px",
                                                fontWeight: 500,
                                            }}
                                        >
                                            Details:{" "}
                                            {`${goldRecords.name} ${goldRecords.brandName} ${isEmpty(goldRecords.articleNumber)
                                                ? ""
                                                : "(" + goldRecords.articleNumber + ")"
                                                }`}
                                        </p>

                                        <p
                                            style={{
                                                margin: "4px 0 0 0",
                                                whiteSpace: "pre-wrap",
                                                overflowWrap: "break-word",
                                                color: "goldenrod",
                                                fontFamily: "sans-serif",
                                                fontSize: "14px",
                                            }}
                                        >
                                            Karat Info: {goldRecords.karatInfo.details}
                                        </p>
                                    </Paper>
                                </Grid>
                            }
                            {
                                !isEmpty(goldRecords.id) &&
                                <Grid item xs={12} md={6} sm={6} lg={6}>
                                    <FormControl component="fieldset">
                                        <FormLabel component="legend"><span style={{ color: "blue", fontWeight: "bold" }}>Select Front Image</span></FormLabel>
                                        <RadioGroup
                                            row
                                            name="thumbnailSelector"
                                            value={goldSupplierRecords.imagePath}
                                            onChange={(e) => setGoldSupplierRecords(
                                                prev => ({
                                                    ...prev, imagePath: e.target.value,
                                                })
                                            )}
                                        >
                                            {(goldRecords?.images?.length ?? 0) > 0 &&
                                                goldRecords.images.map((item, index) => (
                                                    <Card
                                                        key={"Image_" + index}
                                                        variant="outlined"
                                                        sx={{
                                                            m: 1,
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center",
                                                            p: 1,
                                                            border:
                                                                goldSupplierRecords.imagePath === item
                                                                    ? "2px solid #1976d2"
                                                                    : "1px solid #ccc",
                                                        }}
                                                    >
                                                        <img
                                                            src={`${storeApiUrl.BACKEND_BASE_URL}files/${item}`}
                                                            alt={`Image_${index}`}
                                                            style={{
                                                                height: "40px",
                                                                width: "40px",
                                                                borderRadius: "8px",
                                                                objectFit: "cover",
                                                            }}
                                                        />
                                                        <FormControlLabel
                                                            value={item}
                                                            control={<Radio size="small" />}
                                                            label={goldSupplierRecords.imagePath === item ? "Selected" : "Image " + (index + 1)}
                                                            sx={{ mt: -1 }}
                                                        />
                                                    </Card>
                                                ))}
                                        </RadioGroup>
                                    </FormControl> </Grid>
                            }
                            <Grid item xs={12}>
                                <Grid container spacing={1}>
                                    <Grid item md={3} sm={4} lg={3} xs={12}>
                                        <input
                                            accept="image/*"
                                            id="imgPath"
                                            name="imgPath"
                                            type="file"
                                            multiple={5}
                                            onChange={handleImaeUpload}
                                            style={{ display: "none" }}
                                        />
                                        <label htmlFor="imgPath">
                                            <Button
                                                variant="outlined"
                                                component="span"
                                                startIcon={<FileUploadIcon />}
                                                style={{ textTransform: "none", borderRadius: "8px" }}
                                            >
                                                Upload Product Image
                                            </Button>
                                        </label>
                                    </Grid>
                                    {
                                        selectedImage &&
                                        <Card orientation="horizontal" size="md" variant="outlined">
                                            <img
                                                style={{ height: "200px", width: "200px", borderRadius: "1%", objectFit: "contain" }}
                                                src={selectedImage}
                                                alt="preview"
                                            />
                                        </Card>
                                    }
                                    {
                                        !isEmpty(goldSupplierRecords?.gifPath ?? "") &&
                                        <Card orientation="horizontal" size="md" variant="outlined">
                                            <img
                                                style={{ height: "200px", width: "200px", borderRadius: "1%" }}
                                                srcSet={`${storeApiUrl.BACKEND_BASE_URL + "files/" + goldSupplierRecords?.gifPath}`}
                                                src={`${storeApiUrl.BACKEND_BASE_URL + "files/" + goldSupplierRecords?.gifPath}`}
                                            />
                                        </Card>
                                    }
                                </Grid>
                            </Grid>
                            {imageSelectedError &&
                                <Grid container sx={{
                                    mb: 1,
                                }}>
                                    <Grid item xs zeroMinWidth>
                                        <Typography variant="p" color="#EE4B2B" noWrap>Please select the Image (image format) having size below 5Mb</Typography>
                                        <br />
                                        <Typography variant="p" color="#EE4B2B" noWrap>before uploading.</Typography>
                                    </Grid></Grid>

                            }
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={10}>
                    <ThreeDText
                        text="Print/Preview Catalogue Information"
                        display=""
                        className="three-d-text-container"
                        justifyContent="left"
                        alignItems="left" />
                </Grid>
                <Grid item xs={12}>
                    <Paper elevation={10}
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            backgroundColor: "#FEF7DA",
                            boxShadow: 1,
                            borderRadius: 4,
                            padding: 1,
                        }} >
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Stack
                                    direction="row"
                                    spacing={2}
                                    sx={{
                                        width: "100%",
                                    }}
                                >
                                    {/* Left Label */}
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                                            fontWeight: 400,
                                            whiteSpace: 'pre-wrap'
                                            , overflowWrap: 'break-word'
                                        }}
                                    >
                                        Hide Karat Info
                                    </Typography>

                                    {/* Switch */}
                                    <Switch
                                        color="primary"
                                        checked={goldSupplierRecords.showKaratInfo}
                                        onChange={(e) => setGoldSupplierRecords(prev => ({
                                            ...prev, showKaratInfo: e.target.checked,
                                        }))}
                                        inputProps={{ "aria-label": "dark mode" }}
                                    />

                                    {/* Right Label */}
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                                            fontWeight: 400,
                                            whiteSpace: 'pre-wrap'
                                            , overflowWrap: 'break-word'
                                        }}
                                    >
                                        Show Karat Info
                                    </Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={6} sm={6} lg={6}>
                                <Autocomplete
                                    required
                                    id="supplier-select"
                                    options={supplierData}
                                    autoHighlight
                                    variant="filled"
                                    size="small"
                                    onChange={handleSupplierChange}
                                    fullWidth
                                    getOptionLabel={(option) => option.supplierName ?? "No Supplier Selected"}
                                    value={supplierSingleData}
                                    renderOption={(props, option) => (
                                        <Box
                                            component="li"
                                            {...props}
                                        >
                                            {uiUtilInstance.getSupplierLabel(`${storeApiUrl.BACKEND_BASE_URL}files/`, option)}
                                        </Box>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Supplier Information"
                                            inputProps={{
                                                ...params.inputProps,
                                            }}
                                            InputLabelProps={{
                                                style: { fontSize: '18px', fontWeight: 'bold' }, // Adjust font size and weight here
                                            }} />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} sm={6} lg={6}>
                                <Stack
                                    direction="row"
                                    spacing={2} // gap between A, switch, and B
                                    sx={{
                                        width: "100%",
                                    }}
                                >
                                    {/* Left Label */}
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                                            fontWeight: 400,
                                            whiteSpace: 'pre-wrap'
                                            , overflowWrap: 'break-word'
                                        }}
                                    >
                                        Hide Supplier Id/Stamp
                                    </Typography>

                                    {/* Switch */}
                                    <Switch
                                        color="primary"
                                        checked={goldSupplierRecords.showStamp}
                                        onChange={(e) => setGoldSupplierRecords(prev => ({
                                            ...prev, showStamp: e.target.checked,
                                        }))}
                                        inputProps={{ "aria-label": "dark mode" }}
                                    />

                                    {/* Right Label */}
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                                            fontWeight: 400,
                                            whiteSpace: 'pre-wrap'
                                            , overflowWrap: 'break-word'
                                        }}
                                    >
                                        Show Supplier Id/Stamp
                                    </Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={12}>
                                <Stack
                                    direction="row"
                                    spacing={2}
                                    sx={{
                                        width: "100%",
                                    }}
                                >
                                    {/* Left Label */}
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                                            fontWeight: 400,
                                            whiteSpace: 'pre-wrap'
                                            , overflowWrap: 'break-word'
                                        }}
                                    >
                                        Hide Supplier Logo
                                    </Typography>

                                    <Switch
                                        color="primary"
                                        checked={goldSupplierRecords.showLogo}
                                        onChange={(e) => setGoldSupplierRecords(prev => ({
                                            ...prev, showLogo: e.target.checked,
                                        }))}
                                        inputProps={{ "aria-label": "dark mode" }}
                                    />

                                    {/* Right Label */}
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                                            fontWeight: 400,
                                            whiteSpace: 'pre-wrap'
                                            , overflowWrap: 'break-word'
                                        }}
                                    >
                                        Show Supplier Logo
                                    </Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="serialNo"
                                    label="Enter Serial Number"
                                    name="serialNo"
                                    variant="filled"
                                    size="small"
                                    value={goldSupplierRecords.serialNo}
                                    onChange={(e) => setGoldSupplierRecords(prev => ({
                                        ...prev, serialNo: e.target.value,
                                    }))}
                                />
                            </Grid>
                            <Grid item md={6} xs={12} sm={6} lg={6}>
                                <TextField
                                    id="toleranceLevel"
                                    label="Enter Tolerance Level(in milligram)"
                                    name="toleranceLevel"
                                    variant="filled"
                                    type="number"
                                    fullWidth
                                    size="small"
                                    value={goldSupplierRecords.toleranceLevel}
                                    onChange={(e) => setGoldSupplierRecords(prev => ({
                                        ...prev, toleranceLevel: e.target.value,
                                    }))}
                                />
                            </Grid>
                            <Grid item md={6} xs={12} sm={6} lg={6}>
                                <TextField
                                    id="toleranceLevelInPercantage"
                                    label="Enter Tolerance Level(in %)"
                                    name="toleranceLevelInPercantage"
                                    variant="filled"
                                    type="number"
                                    fullWidth
                                    size="small"
                                    value={goldSupplierRecords.toleranceLevelInPercantage}
                                    onChange={(e) => setGoldSupplierRecords(prev => ({
                                        ...prev, toleranceLevelInPercantage: e.target.value,
                                    }))}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} sm={6} lg={6}>
                                <Stack
                                    direction="row"
                                    spacing={2} // gap between A, switch, and B
                                    sx={{
                                        width: "100%",
                                    }}
                                >
                                    {/* Left Label */}
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                                            fontWeight: 400,
                                            whiteSpace: 'pre-wrap'
                                            , overflowWrap: 'break-word'
                                        }}
                                    >
                                        Hide Tolerance Level
                                    </Typography>

                                    {/* Switch */}
                                    <Switch
                                        color="primary"
                                        checked={goldSupplierRecords.showTolerance}
                                        onChange={(e) => setGoldSupplierRecords(prev => ({
                                            ...prev, showTolerance: e.target.checked,
                                        }))}
                                        inputProps={{ "aria-label": "dark mode" }}
                                    />

                                    {/* Right Label */}
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                                            fontWeight: 400,
                                            whiteSpace: 'pre-wrap'
                                            , overflowWrap: 'break-word'
                                        }}
                                    >
                                        Show Tolerance Level
                                    </Typography>
                                </Stack>
                            </Grid>
                            {
                                (listConversion && listConversion.length > 0) &&
                                <Grid item xs={12} md={6} sm={6} lg={6}>
                                    <FormControl component="fieldset">
                                        <FormLabel component="legend"><span style={{ color: "blue", fontWeight: "bold" }}>Select Unit: {goldRecords.cnvDetails}</span></FormLabel>
                                        <RadioGroup
                                            aria-label="conversionId"
                                            name="conversionId"
                                            value={Number(goldSupplierRecords.conversionId)}
                                            onChange={(e) => setGoldSupplierRecords(
                                                prev => ({
                                                    ...prev, conversionId: Number(e.target.value),
                                                })
                                            )}
                                            row={true}
                                        >
                                            {listConversion.map((item, index) => (
                                                <FormControlLabel
                                                    key={index}
                                                    value={item.id}
                                                    control={<Radio />}
                                                    label={item.value}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            }
                            <Grid item md={6} xs={12} sm={6} lg={6}>
                                <TextField
                                    id="weight"
                                    label="Enter Weight"
                                    name="weight"
                                    variant="filled"
                                    type="number"
                                    size="small"
                                    fullWidth
                                    value={goldSupplierRecords.weight}
                                    onChange={(e) => setGoldSupplierRecords(prev => ({
                                        ...prev, weight: e.target.value,
                                    }))}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    id="search-front-color"
                                    name="search-front-color"
                                    options={listColor}
                                    autoHighlight
                                    variant="filled"
                                    size="small"
                                    fullWidth
                                    value={frontColorModel}
                                    onChange={handleSelectColorChange}
                                    onBlur={(e) => setListColor([])}
                                    isOptionEqualToValue={(option, value) => option?.colorId === value?.colorId}
                                    getOptionLabel={(option) => option?.colorDetails || ''}
                                    renderOption={(props, option) => (
                                        <li {...props} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <div
                                                style={{
                                                    width: 20,
                                                    height: 20,
                                                    backgroundColor: option.colorDetails.split(" ")[0],
                                                    border: "1px solid #ccc",
                                                    borderRadius: 4,
                                                }}
                                            />
                                            {option.colorDetails}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Search Front Color"
                                            name="search-front-color"
                                            onChange={handleSearchColor}
                                            inputProps={{
                                                ...params.inputProps,
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    id="search-back-color"
                                    name="search-back-color"
                                    options={listBackColor}
                                    autoHighlight
                                    variant="filled"
                                    size="small"
                                    fullWidth
                                    value={backColor}
                                    onChange={handleBackColor}
                                    onBlur={(e) => setListBackColor([])}
                                    isOptionEqualToValue={(option, value) => option?.colorId === value?.colorId}
                                    getOptionLabel={(option) => option?.colorDetails || ''}
                                    renderOption={(props, option) => (
                                        <li {...props} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <div
                                                style={{
                                                    width: 20,
                                                    height: 20,
                                                    backgroundColor: option.colorDetails.split(" ")[0],
                                                    border: "1px solid #ccc",
                                                    borderRadius: 4,
                                                }}
                                            />
                                            {option.colorDetails}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Search Back Color"
                                            name="search-back-color"
                                            onChange={handleSearchColor}
                                            inputProps={{
                                                ...params.inputProps,
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Select Item Status</FormLabel>
                                    <RadioGroup aria-label="itemStatus" name="itemStatus" value={goldSupplierRecords.itemStatus} onChange={(e) => setGoldSupplierRecords(prev => ({
                                        ...prev, itemStatus: Number(e.target.value),
                                    }))}
                                        row={true}>

                                        <FormControlLabel value={ItemStatus.ACTIVE} control={<Radio />} label="Active" />
                                        <FormControlLabel value={ItemStatus.INACTIVE} control={<Radio />} label="InActive" />

                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            {
                                !isEmpty(goldSupplierRecords.id) &&
                                <Grid item xs={12}>
                                    <SnpButton variant="contained" mbgcolor="#0073ae" onPointerDown={() => {
                                        navigate("/dashboard/showgoldsupplierrecord", { state: { inventoryId: goldRecords.id, supId: supplierSingleData.supplierId, } });
                                    }}>
                                        Show All Records
                                    </SnpButton>
                                </Grid>
                            }
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={6} sm={6} lg={6}>
                    <SnpButton variant="contained" mbgcolor={!isEmpty(goldSupplierRecords.id) ? "#764032" : "#01333e"}
                        onPointerDown={() => handleImageUpload()}>
                        {!isEmpty(goldSupplierRecords.id) ? "Update" : "Create"}
                    </SnpButton>
                </Grid>
                <Grid item xs={12} md={6} sm={6} lg={6}>
                    <DismissButton variant="contained" onPointerDown={() => navigate("/dashboard/showproduct")}>
                        Dismiss
                    </DismissButton>
                </Grid>
                {
                    !isEmpty(goldSupplierRecords.id) &&
                    <Grid item xs={12} md={6} sm={6} lg={6}>
                        <SnpButton variant="contained" color="bRed" onPointerDown={() => deleteProduct()}>
                            Delete Product
                        </SnpButton>
                    </Grid>
                }
                {
                    !isEmpty(goldSupplierRecords.id) &&
                    <Grid item xs={12} md={6} sm={6} lg={6}>
                        <SnpButton variant="contained" mbgcolor="#8b0000" onPointerDown={() => handlePreviewEcart()}>
                            Preview Product
                        </SnpButton>
                    </Grid>
                }

                {
                    !isEmpty(goldSupplierRecords.id) &&
                    <Grid item xs={12} md={6} sm={6} lg={6}>
                        <SnpButton variant="contained" mbgcolor="#8b0000" onPointerDown={() => printProduct()}>
                            Print Product
                        </SnpButton>
                    </Grid>
                }
            </Grid>

        </SnpBaseLayout>
    )

};

export default GoldSupplierRecord;